import { SectionBox } from "common/styleguide/SectionBox";
import { messages as overviewMessages } from "features/challenges/admin/Overview";
import { OrgContext } from "features/organizations/OrgContext";
import { featureNames } from "lib/localization";
import React, { useContext } from "react";
import { Link } from "react-router-dom";
import { Completed } from "../ChallengeShowPage";
import lockedMilestone from "./lockedMilestone.png";
import styles from "./MilestonesCard.scss";

export const MilestonesCard = ({ goal, metaForGoal, milestones, currentUserParticipant, preview, fm }) => {
  const { isCurrentClub } = useContext(OrgContext);
  return (
    <SectionBox title={fm(featureNames.milestones)}>
      {milestones
        .sortBy((m) => m.targetValue)
        .map((m) => (
          <Milestone
            key={m.id}
            m={m}
            p={currentUserParticipant}
            goal={goal}
            communityCompleted={metaForGoal.community.completed}
            fm={fm}
          />
        ))
        .toIndexedSeq()}
      {isCurrentClub && !preview && (
        <Link className={styles.link} to={`/challenges/${goal.get("id")}/settings#milestones`}>
          {fm(overviewMessages.viewMilestones)}
        </Link>
      )}
    </SectionBox>
  );
};

const Milestone = ({ m, p, goal, communityCompleted, fm }) => {
  let userHasMet;
  if (goal.get("goalParams")["participation_type"] === "community") {
    userHasMet =
      m.targetType === "percent"
        ? communityCompleted / goal.goalParams.target_amount > m.targetValue
        : communityCompleted > m.targetValue;
  } else {
    userHasMet =
      m.targetType === "percent"
        ? p?.amountCompleted / goal.goalParams.target_amount > m.targetValue / 100
        : p?.amountCompleted > m.targetValue;
  }

  return (
    <div className={styles.milestone}>
      <img src={m.badge} />
      {p && !userHasMet && <img src={lockedMilestone} className={styles.locked} />}
      <div className={styles.info}>
        <div className={styles.title}>{m.title}</div>
        <div className={styles.subInfo}>{m.overview}</div>
        <div className={styles.subInfo}>
          {m.targetType === "percent" ? (
            `${m.targetValue}%`
          ) : (
            <Completed noLabel value={m.targetValue} goalType={goal.goalType} />
          )}
        </div>
      </div>
    </div>
  );
};
